import useReferral from 'features/referral/hooks/useReferral';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import Step from './Step';

const referrerSteps = [
  {
    step: 1,
    title: 'label_referral_tab_1_question_title_1',
    content: 'label_referral_tab_1_question_desc_1',
  },
  {
    step: 2,
    title: 'label_referral_tab_1_question_title_2',
    content: 'label_referral_tab_1_question_desc_2',
  },
  {
    step: 3,
    title: 'label_referral_tab_1_question_title_3',
    content: 'label_referral_tab_1_question_desc_3',
  },
];
const refereeSteps = [
  {
    step: 1,
    title: '',
    content: 'label_referee_tab_1_question_desc_1',
  },
  {
    step: 2,
    title: '',
    content: 'label_referee_tab_1_question_desc_2',
  },
  {
    step: 3,
    title: '',
    content: 'label_referee_tab_1_question_desc_3',
  },
];

const ReferralContentTab1 = () => {
  const { t } = useLang();
  const { isReferee1st } = useReferral();

  const getSteps = () => {
    if (isReferee1st) return refereeSteps;
    return referrerSteps;
  };

  const getNotice = () => {
    if (isReferee1st) return 'label_referee_tab_1_notice';
    return '';
  };

  return (
    <ReferralContentTabStyled>
      {getSteps().map((s) => (
        <StepContent key={s.step}>
          <Step step={s.step} />
          <TitleContentWrap>
            {s?.title && <Title>{t(s.title)}</Title>}
            {s?.content && <Content>{t(s.content)}</Content>}
          </TitleContentWrap>
        </StepContent>
      ))}
      {getNotice() && (
        <NoticeWrap>
          <NoticeText>{t(getNotice())}</NoticeText>
        </NoticeWrap>
      )}
    </ReferralContentTabStyled>
  );
};

export const ReferralContentTabStyled = styled.div`
  width: 100%;
  height: fit-content;
`;

const StepContent = styled.div`
  display: grid;
  grid-template-columns: 24px calc(100% - 24px - 4px);
  gap: 4px;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0px;
  }
`;

const TitleContentWrap = styled.div`
  display: grid;
  grid-gap: 2px;
`;
const Title = styled.p`
  ${paragraphMixin};
  font-weight: 700;
  width: 100%;
`;
const Content = styled.p`
  ${paragraphMixin};
  font-weight: 500;
  width: 100%;
`;

const NoticeWrap = styled.div`
  background: #fef0d1;
  padding: 8px;
  display: flex;
  align-items: start;
  gap: 0px;
  border-radius: 12px;
`;
const NoticeText = styled.p`
  ${paragraphMixin};
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
`;

export default ReferralContentTab1;
